import { atom } from "jotai";

export const createFormActiveStepAtom = atom(2);
export const createFormMarketId = atom<number | null>(null);
export const createFormMarketUrlPath = atom<string>("");
